export const PRE_SELECTED_COUNTRIES_PER_LANGUAGE = {
  es: '+34',
  ca: '+34',
  eu: '+34',
  pt: '+351',
};
